import { useState } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow, MDBTypography, MDBIcon, MDBBtn, MDBInput, MDBCollapse } from "mdb-react-ui-kit"
import { useTranslation } from "react-i18next"
import { transformMoney } from "../../../utils/money"
import { priceBreakdownOf } from "../../event-management/booking/interactive/boothMapView"
import { priceBreakdownLines } from "../../event-management/booking/interactive/boothStatusText"

export default function SideCart({params, products = [], customerType, hideDescription = false, hideImage = false, taxRate, showDiscountCode, discountCode, setDiscountCode, applyDiscountCode, removeDiscountCode, appliedDiscounts, discountErrorMessages, showBreakdownAlways = false}) {
  const { t, i18n } = useTranslation();
  const [showDiscountInput, setShowDiscountInput] = useState(false);
  const [showBreakdown, setShowBreakdown] = useState(false);
  const breakdownVisible = showBreakdownAlways || showBreakdown;

  const toggleDiscountInput = () => {
    setShowDiscountInput(!showDiscountInput);
  };

  const taxMultiplier = 1 + taxRate / 100;
  // breakdown amounts in the same (gross) terms as the cart lines
  const formatCartMoney = (value) => transformMoney(value * taxMultiplier);

  return (
    <>
      <MDBCard>
        <MDBCardBody>
          <MDBCardTitle>{t("Cart")}</MDBCardTitle>
          <MDBRow className="mt-3">
            {products.length > 0 && products.map((product) => (
              <MDBCol key={`product-${product.lineBoothNumber ? `${product.id}#${product.lineBoothNumber}` : product.id}`} md='12' className='mb-4'>
                <MDBRow>
                  <MDBCol md='2'>
                    {product?.image?.main?.url || product?.image?.main?.fileName ?
                    <MDBCol md='12'><img src={product?.image?.main?.url || "https://iec-cp-public.s3.eu-central-1.amazonaws.com/ProductImages/" + product?.image?.main.fileName} alt={product?.name.find(n => n.language === i18n.language)?.text || product?.name[0]?.text} className='img-fluid' /></MDBCol>
                    : <MDBIcon className="" style={{ height: "50px", width: "50px", textAlign: "center", paddingTop: "12px", fontSize: "20px" }} fas icon={product.icon} />}
                  </MDBCol>
                  <MDBCol md='6'>
                    <MDBTypography tag='h6' className="fw-bold">
                      {product.qty && product.qty > 1 && <span className="me-2">{product.qty}x</span>}
                      {product?.name.find(n => n.language === i18n.language)?.text || product?.name[0]?.text}
                      </MDBTypography>
                    {product.lineBoothNumber && (
                      <MDBTypography tag='p' className="small text-muted mb-1">
                        <MDBIcon fas icon="map-marker-alt" className="me-1" />
                        {t("Booth {{number}}", { number: product.lineBoothNumber })}
                      </MDBTypography>
                    )}
                    {product.lineBoothNumber && priceBreakdownLines(t, priceBreakdownOf(product.priceDetails), formatCartMoney).map((line, index) => (
                      <MDBTypography key={`price-line-${index}`} tag='p' className="small text-muted mb-1" data-testid="cart-price-breakdown">
                        {line}
                      </MDBTypography>
                    ))}
                    {!hideDescription && <MDBTypography tag='p'>{product?.shortDescription?.find(n => n.language === i18n.language)?.text || product?.shortDescription?.[0]?.text}</MDBTypography>}
                  </MDBCol>
                  <MDBCol md='4'>
                    <MDBTypography tag='h6' className='text-end'>
                      {transformMoney((product.qty && product.qty > 1 ? product?.price * product.qty : product?.price) * taxMultiplier)}
                      </MDBTypography>
                    {product.qty && product.qty > 1 && (
                      <MDBTypography tag='p' className='text-end text-muted small mb-0'>
                        {product.qty} x {transformMoney(product?.price * taxMultiplier)}
                      </MDBTypography>
                    )}
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            ))}
            {appliedDiscounts?.length > 0 && appliedDiscounts.map((discount) => (
              <MDBCol key={`discount-${discount.id}`} md='12' className='mb-4'>
                <MDBRow>
                  <MDBCol md='2'>
                    <MDBIcon className="" style={{ height: "50px", width: "50px", textAlign: "center", paddingTop: "12px", fontSize: "20px" }} fas icon="tag" />
                  </MDBCol>
                  <MDBCol md='6'>
                    <MDBTypography tag='h6' className="fw-bold">
                      {discount?.name?.find(n => n.language === i18n.language)?.text || discount?.name?.[0]?.text || discount?.code}
                      <MDBIcon fas icon="times" className="ms-2 text-danger" style={{cursor: 'pointer'}} onClick={() => removeDiscountCode(discount.id)} />
                      </MDBTypography>
                    {discount?.isFromInvitation && <small className="text-muted">{t("Invitation discount")}</small>}
                  </MDBCol>
                  <MDBCol md='4'>
                    <MDBTypography tag='h6' className='text-end'>
                      -{transformMoney(discount?.amount * taxMultiplier)}
                      </MDBTypography>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
            ))}
          </MDBRow>

          {/* Discount Code */}
          {showDiscountCode && (
            <MDBRow className="mb-3">
              <MDBCol md='12'>
                {!showDiscountInput ? (
                  <MDBTypography
                    tag='span'
                    className="text-primary"
                    style={{cursor: 'pointer'}}
                    onClick={toggleDiscountInput}
                  >
                    <MDBIcon fas icon="tag" className="me-2" />
                    {t("Add Discount")}
                  </MDBTypography>
                ) : (
                  <>
                    <MDBTypography tag='h6'>{t("Discount code")}</MDBTypography>
                    <MDBRow>
                      <MDBCol md='8'>
                        <MDBInput
                          type="text"
                          value={discountCode}
                          onChange={(e) => setDiscountCode(e.target.value)}
                        />
                      </MDBCol>
                      <MDBCol md='4'>
                        <MDBBtn outline onClick={applyDiscountCode}>{t("Apply")}</MDBBtn>
                      </MDBCol>
                    </MDBRow>
                    {discountErrorMessages?.length > 0 && (
                      <MDBTypography tag='p' className="text-danger mt-2">
                        {discountErrorMessages.join(", ")}
                      </MDBTypography>
                    )}
                  </>
                )}
              </MDBCol>
            </MDBRow>
          )}

          <hr />
          {/* Gross total - prominent */}
          <MDBRow>
            <MDBCol md='6'>
              <MDBTypography tag='h6' className="fw-bold">{t("Total")}</MDBTypography>
            </MDBCol>
            <MDBCol md='6'>
              <MDBTypography tag='h6' className='text-end fw-bold'>{
                transformMoney(
                  (products.reduce((acc, product) => acc + (product.qty && product.qty > 1 ? product?.price * product.qty : product?.price), 0) * taxMultiplier)
                  - (appliedDiscounts?.length > 0 ? appliedDiscounts.reduce((acc, discount) => acc + discount.amount * taxMultiplier, 0) : 0)
                )
              }</MDBTypography>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol md='12'>
              <small className="text-muted">
                {taxRate > 0 ? t("inkl. {{taxRate}}% MwSt", { taxRate }) : t("Net (VAT exempt)")}
              </small>
            </MDBCol>
          </MDBRow>

          {/* Price breakdown */}
          {taxRate > 0 && <>
            {!showBreakdownAlways &&
              <MDBTypography
                tag='span'
                className="text-primary small"
                style={{ cursor: 'pointer' }}
                onClick={() => setShowBreakdown(!showBreakdown)}
              >
                <MDBIcon fas icon={showBreakdown ? "chevron-down" : "chevron-right"} className="me-1" />
                {t("Price breakdown")}
              </MDBTypography>
            }
            {showBreakdownAlways ? (
              <div className="mt-2">
                <MDBRow>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className="text-muted mb-1">{t("Net amount")}</MDBTypography>
                  </MDBCol>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className='text-end text-muted mb-1'>{
                      transformMoney(
                        (products.reduce((acc, product) => acc + (product.qty && product.qty > 1 ? product?.price * product.qty : product?.price), 0))
                        - (appliedDiscounts?.length > 0 ? appliedDiscounts.reduce((acc, discount) => acc + discount.amount, 0) : 0)
                      )
                    }</MDBTypography>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className="text-muted mb-0">{t("VAT")} ({taxRate}%)</MDBTypography>
                  </MDBCol>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className='text-end text-muted mb-0'>{
                      transformMoney(
                        (products.reduce((acc, product) => acc + (product.qty && product.qty > 1 ? product?.price * product.qty : product?.price), 0) * taxRate / 100)
                        - (appliedDiscounts?.length > 0 ? appliedDiscounts.reduce((acc, discount) => acc + discount.amount * taxRate / 100, 0) : 0)
                      )
                    }</MDBTypography>
                  </MDBCol>
                </MDBRow>
              </div>
            ) : (
              <MDBCollapse open={showBreakdown}>
                <MDBRow className="mt-2">
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className="text-muted mb-1">{t("Net amount")}</MDBTypography>
                  </MDBCol>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className='text-end text-muted mb-1'>{
                      transformMoney(
                        (products.reduce((acc, product) => acc + (product.qty && product.qty > 1 ? product?.price * product.qty : product?.price), 0))
                        - (appliedDiscounts?.length > 0 ? appliedDiscounts.reduce((acc, discount) => acc + discount.amount, 0) : 0)
                      )
                    }</MDBTypography>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className="text-muted mb-0">{t("VAT")} ({taxRate}%)</MDBTypography>
                  </MDBCol>
                  <MDBCol md='6'>
                    <MDBTypography tag='p' className='text-end text-muted mb-0'>{
                      transformMoney(
                        (products.reduce((acc, product) => acc + (product.qty && product.qty > 1 ? product?.price * product.qty : product?.price), 0) * taxRate / 100)
                        - (appliedDiscounts?.length > 0 ? appliedDiscounts.reduce((acc, discount) => acc + discount.amount * taxRate / 100, 0) : 0)
                      )
                    }</MDBTypography>
                  </MDBCol>
                </MDBRow>
              </MDBCollapse>
            )}
          </>}
        </MDBCardBody>
      </MDBCard>
    </>
  )
}
